import React from "react";
import RemergeApi from "shared/http/RemergeApi";

const RemergeAPIContext: React.Context<RemergeApi> = React.createContext(undefined) as any;
const { Provider: RemergeAPIProvider, Consumer: RemergeAPIConsumer } = RemergeAPIContext;

export { RemergeAPIConsumer, RemergeAPIContext, RemergeAPIProvider };
